import { NatalChart } from '../entities';

export const natalChartInitialState: NatalChart = {
  natalChartData: {
    astroData: {
      Sun: [],
      Moon: [],
      Mercury: [],
      Venus: [],
      Mars: [],
      Jupiter: [],
      Saturn: [],
      Uranus: [],
      Neptune: [],
      Pluto: [],
      Chiron: [],
    },
    cusps: [],
    planetsInHouse: {
      sun: 0,
      moon: 0,
      mercury: 0,
      venus: 0,
      mars: 0,
      jupiter: 0,
      saturn: 0,
      uranus: 0,
      neptune: 0,
      pluto: 0,
      chiron: 0,
    },
  },
  signsInfo: {
    sunSign: '',
    moonSign: '',
    ascendantSign: '',
    venusSign: '',
    seventhHouseSign: '',
    marsSign: '',
    fifthHouseSign: '',
    mercurySign: '',
    tenthHouseSign: '',
    secondHouseSign: '',
  },
};
